import React from "react";
import {
  FaRocket,
  FaUniversity,
  FaTruck,
  FaHotel,
  FaIndustry,
  FaGraduationCap,
  FaHeartbeat,
  FaShoppingCart,
} from "react-icons/fa";
import "./IndustriesSection.css";

const industries = [
  { name: "Startups & MSMEs", icon: <FaRocket /> },
  { name: "Government & Public Sector", icon: <FaUniversity /> },
  { name: "Logistics & Transportation", icon: <FaTruck /> },
  { name: "Hospitality & Service Industry", icon: <FaHotel /> },
  { name: "Manufacturing & Industrial", icon: <FaIndustry /> },
  { name: "Education Industry", icon: <FaGraduationCap /> },
  { name: "Healthcare Industry", icon: <FaHeartbeat /> },
  { name: "Retail & E-Commerce", icon: <FaShoppingCart /> },
];

const IndustriesSection = () => {
  return (
    <section className="industries-wrapper">
      <div className="industries-header">
        <h2>Industries We Serve</h2>
        <p>
          Delivering future-ready digital solutions across multiple industries.
        </p>
      </div>

      <div className="industries-grid">
        {industries.map((industry, index) => (
          <div key={index} className="industry-card">
            <div className="icon-circle">{industry.icon}</div>
            <h3>{industry.name}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IndustriesSection;